import React, { useEffect } from 'react';
import { overridable } from '@24i/nxg-sdk-gluons/src/context/ComponentOverrides';
import { withSignoutModal, SignoutModalProps } from '../../../components/SignOut';
import { useStore } from '../../../context/ApplicationStore';

const SignoutScreen = ({ setSignoutModalVisible }: SignoutModalProps) => {
    const { userData } = useStore();

    useEffect(() => {
        if (!userData?.id) return; // avoid to show logout modal if user logged out

        setSignoutModalVisible(true);
    }, [userData?.id]);
    return <></>;
};

export default overridable(withSignoutModal(SignoutScreen), 'SignoutScreen');
